import Vue from 'vue';
import axios from 'axios';
import { EventBus } from '../../event/event-bus.js';
window.eventHub = new Vue();
export default {
  post(request) {
    if (!request.stopAjaxLoading) {
      EventBus.$emit('show-ajax-loading', true);
    }
    var axiosConfig = {};
    if (process.env.NODE_ENV == 'development') {
      axiosConfig = {
        withCredentials: true,
        headers: {'Content-Type': 'application/x-www-form-urlencoded'},
      };
    }else{
      axiosConfig = {
        withCredentials: true,
      };
    }
    return axios
      .post(`${window.serverURL}ajax.php`, request, axiosConfig)
      .then(response => {
        EventBus.$emit('show-ajax-loading', false);
        let data = response.data;
        if (
          data & data.generalCheckV3 &&
          data.generalCheckV3['V3UpdateAvailable']
        ) {
          eventHub.$emit('updateAvailable', {
            update: data.generalCheckV3['V3UpdateAvailable']
          });
        }
        if (data && data.notifications) {
          console.log('got a new notification');
          eventHub.$emit('sendNotification', {
            notifications: data.notifications
          });
        }
        if (data && data.actionResult && data.actionResult.title) {
          console.log('got a new notification');
          eventHub.$emit('sendTaskNotification', {
            notifications: data.actionResult
          });
        }
        if (data && data.fireQueue) {
          console.log('got a new fireQueue');
          console.log(data.fireQueue);
          if(data.fireQueue.installCloneCompleted){
             eventHub.$emit('fireQueue', {
              fireQueue: {
                getSitesV3:data.fireQueue.installCloneCompleted.getSitesV3,
              }
            });
         }else if(data.fireQueue.stagingCompleted){
            eventHub.$emit('fireQueue', {
              fireQueue: {
                getSitesV3:data.fireQueue.stagingCompleted.getSitesV3,
              }
            }); 
         }
        }
        if (data && data.data && data.data.getWaitData) {
          eventHub.$emit('refreshHistoryImmediately', {
            forcedAjaxInterval: 1
          });
        } else if (
          data &&
          typeof data.sendNextAjaxCallAfter != 'undefined' &&
          data.sendNextAjaxCallAfter != null
        ) {
          eventHub.$emit('refreshHistory', {
            sendNextAjaxCallAfter: data.sendNextAjaxCallAfter,
            forcedAjaxInterval: 5
          });
        } else {
          eventHub.$emit('clearRefreshHistory');
        }
        return Promise.resolve(response.data);
      })
      .catch(error => Promise.reject(error));
  }
};
